module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-double-height-living-5c483f1a.jpg";